import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const LEGAL_SHIELD_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.legalShield.buyBox.bulletPoint1' },
        { title: 'productPage.legalShield.buyBox.bulletPoint2' },
        { title: 'productPage.legalShield.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.legalShield.buyBox.productName',
      interactService: {
        service: 'legal_shield',
        openInNewTab: true
      }
    }],
    headerPicture: {
      src: '/s2/raster/construction-roof-hammer.png',
      alt: 'productPage.legalShield.heroPicture.altText'
    },
    headline: 'productPage.legalShield.page.headline',
    partnerLogo: {
      src: '/s2/vector/legalshield-logo-horiz.svg',
      alt: ''
    },
    partnerReviewBlanks: [
      {
        text: 'productPage.legalShield.page.reviewText1'
      },
      {
        src: '/illustration/trustpilot-4.5-star.svg',
        showOnMobile: true,
        alt: ''
      },
      {
        src: '/illustration/trustpilot-logo.svg',
        alt: ''
      }
    ],
    subheader: 'productPage.legalShield.page.subheader'
  },
  benefit: {
    title: 'productPage.legalShield.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/lightbulbrounded.svg',
        title: 'productPage.legalShield.valueProp.propTitle1',
        description: 'productPage.legalShield.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/paymentsrounded.svg',
        title: 'productPage.legalShield.valueProp.propTitle2',
        description: 'productPage.legalShield.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/notealtrounded.svg',
        title: 'productPage.legalShield.valueProp.propTitle3',
        description: 'productPage.legalShield.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/personpinrounded.svg',
        title: 'productPage.legalShield.valueProp.propTitle4',
        description: 'productPage.legalShield.valueProp.shortCopy4'
      },
      {
        icon: '/s2/material-icons/badgerounded.svg',
        title: 'productPage.legalShield.valueProp.propTitle5',
        description: 'productPage.legalShield.valueProp.shortCopy5'
      },
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.legalShield.valueProp.propTitle6',
        description: 'productPage.legalShield.valueProp.shortCopy6'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/gppgoodrounded.svg',
    title: 'productPage.legalShield.topFeature.title',
    subheader: 'productPage.legalShield.topFeature.subheader',
    image: '/s2/raster/gardener-note-phonecall.png',
    alt: 'productPage.legalShield.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.legalShield.howItWorks.title',
    items: [
      {
        title: 'productPage.legalShield.howItWorks.step1',
        description: 'productPage.legalShield.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.legalShield.howItWorks.step2',
        description: 'productPage.legalShield.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.legalShield.howItWorks.step3',
        description: 'productPage.legalShield.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/welder-sparks-blue.png',
    alt: 'productPage.legalShield.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  assistance: {
    title: 'productPage.legalShield.needAssistance.title',
    getInTouch: 'productPage.legalShield.needAssistance.getInTouch',
    actions: 'productPage.legalShield.needAssistance.actions'
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.legalShield.buyBox.buttonLabel'
  })
};
